import { generateFormValidations } from "../../../../helpers/antdFormValidations";
import { FleetExpenseFormValues } from "./types";

const fleetExpenseModalValidations = generateFormValidations<FleetExpenseFormValues>(
  {
    driver_id: [{ required: true, message: "Driver is required" }],
    tc_id: [{ required: true, message: "TC is required" }],
    spending_type_id: [
      { required: true, message: "Spending type is required" },
    ],
    date: [{ required: true, message: "Date is required" }],
    amount: [{ required: true, message: "Amount is required" }],
    currency: [{ required: true, message: "Currency is required" }],
    payment_type: [{ required: true, message: "Payment type is required" }],
  }
);

export default fleetExpenseModalValidations;
